import React from 'react';
import styled from 'styled-components';
import Button from './Button';

const FullScreen = styled.div`
  position: fixed;
  z-index: 30;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(2px);
`;

const AskModalBlock = styled.div`
  min-width: 400px;
  max-width: 500px;
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.2s ease-out;
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  h2 {
    margin: 0 0 1rem 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #212529;
  }
  
  p {
    margin-bottom: 2rem;
    line-height: 1.6;
    color: #495057;
    font-size: 1rem;
    white-space: pre-line;
  }
  
  .buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
  }
`;

const StyledButton = styled(Button)`
  height: 2.5rem;
  padding: 0 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

const AskModal = ({
  visible,
  title,
  description,
  confirmText = '확인',
  cancelText = '취소',
  onConfirm,
  onCancel,
}) => {
  if (!visible) return null;
  return (
    <FullScreen>
      <AskModalBlock>
        <h2>{title}</h2>
        <p>{description}</p>
        <div className="buttons">
          <StyledButton onClick={onConfirm}>{confirmText}</StyledButton>
          <StyledButton onClick={onCancel}>{cancelText}</StyledButton>
        </div>
      </AskModalBlock>
    </FullScreen>
  );
};

export default AskModal;
